import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

interface MSTeamsIconProps extends SvgIconProps { }

const MSTeamsIcon: FunctionComponent<MSTeamsIconProps> = (props) => {
	return (
		<SvgIcon viewBox="0 0 56 57" {...props}>
			<path d="M51.3335 26.1663V35.4997C51.3335 39.366 48.1998 42.4997 44.3335 42.4997C40.4672 42.4997 37.3335 39.366 37.3335 35.4997V23.833H49.0002C50.2893 23.833 51.3335 24.8772 51.3335 26.1663ZM44.3335 19.1663C46.9107 19.1663 49.0002 17.0768 49.0002 14.4997C49.0002 11.9225 46.9107 9.83301 44.3335 9.83301C41.7563 9.83301 39.6668 11.9225 39.6668 14.4997C39.6668 17.0768 41.7563 19.1663 44.3335 19.1663Z" fill="#E4E8F0" />
			<path d="M40.8333 26.1663V38.9997C40.8333 45.6998 35.1855 51.0817 28.3897 50.6407C22.1888 50.2393 17.5 44.8132 17.5 38.5995V23.833H38.5C39.7892 23.833 40.8333 24.8772 40.8333 26.1663ZM29.1667 20.333C33.033 20.333 36.1667 17.1993 36.1667 13.333C36.1667 9.46667 33.033 6.33301 29.1667 6.33301C25.3003 6.33301 22.1667 9.46667 22.1667 13.333C22.1667 17.1993 25.3003 20.333 29.1667 20.333Z" fill="#F5F6FA" />
			<path d="M29.1665 20.333C33.0325 20.333 36.1665 17.199 36.1665 13.333C36.1665 9.46701 33.0325 6.33301 29.1665 6.33301C25.3005 6.33301 22.1665 9.46701 22.1665 13.333C22.1665 17.199 25.3005 20.333 29.1665 20.333Z" fill="#F5F6FA" />
			<path
				d="M30.3333 39.3718V23.833H17.5V38.5995C17.5 40.3892 17.9002 42.1088 18.6013 43.6663H26.0377C28.4107 43.6663 30.3333 41.7437 30.3333 39.3718Z"
				fill="#E4E8F0"
				opacity="0.05"
			/>
			<path
				d="M17.5 23.833V38.5995C17.5 39.9528 17.7345 41.2642 18.1463 42.4997H25.914C27.9253 42.4997 29.5552 40.8698 29.5552 38.8585V23.833H17.5Z"
				fill="#E4E8F0"
				opacity="0.07"
			/>
			<path
				d="M28.7782 23.833H17.5V38.5995C17.5 39.5352 17.6178 40.4475 17.8197 41.333H25.7903C27.44 41.333 28.777 39.996 28.777 38.3463V23.833H28.7782Z"
				fill="#E4E8F0"
				opacity="0.09"
			/>
			<path d="M25.6665 40.1663H6.99984C5.71067 40.1663 4.6665 39.1222 4.6665 37.833V19.1663C4.6665 17.8772 5.71067 16.833 6.99984 16.833H25.6665C26.9557 16.833 27.9998 17.8772 27.9998 19.1663V37.833C27.9998 39.1222 26.9557 40.1663 25.6665 40.1663Z" fill="#E4E8F0" />
			<path d="M21.0794 22.665H11.5874V24.6717H15.1422V34.3317H17.5246V24.6717H21.0794V22.665Z" fill="white" />
		</SvgIcon>
	);
};

export default MSTeamsIcon;